
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { PatientIcon, ProviderIcon } from '@/components/icons/NavigationIcons';

const AboutDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  const aboutItems = [
    { name: "Our Story", href: "/about" },
    { name: "Meet the Team", href: "/team" },
    { name: "Studio Design", href: "/about#design" },
    { name: "Careers", href: "/careers" }
  ];

  const portalItems = [
    { 
      name: "Patient Portal", 
      href: "/portal", 
      icon: <PatientIcon size={18} className="text-juv-terracotta" />,
      description: "Access your account"
    },
    { 
      name: "Provider Portal", 
      href: "/staff", 
      icon: <ProviderIcon size={18} className="text-juv-terracotta" />,
      description: "Staff dashboard"
    },
    { 
      name: "Become a Partner", 
      href: "/partner", 
      icon: null,
      description: "Join our network"
    }
  ];

  return (
    <div 
      className="relative"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button className="flex items-center space-x-1 text-juv-deep-chestnut hover:text-juv-terracotta transition-colors font-light tracking-wide py-2">
        <span>About</span>
        <ChevronDown size={16} className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="absolute top-full right-0 mt-2 w-64 z-50"
          >
            <div className="bg-white/95 backdrop-blur-md border border-juv-rose-clay/20 rounded-2xl shadow-luxury overflow-hidden">
              <div className="py-4">
                <div className="px-6 pb-4 border-b border-juv-rose-clay/20">
                  <h4 className="font-semibold text-juv-deep-chestnut mb-1">About JUV</h4>
                </div>
                <div className="space-y-1 px-2 py-2">
                  {aboutItems.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="block px-4 py-3 text-gray-600 hover:text-juv-terracotta hover:bg-juv-soft-blush/10 transition-all duration-200 rounded-lg"
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
                
                <div className="px-6 pt-4 pb-2 border-t border-juv-rose-clay/20 mt-2">
                  <h4 className="font-semibold text-juv-deep-chestnut mb-1">Portals</h4>
                </div>
                <div className="space-y-1 px-2 pb-2">
                  {portalItems.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="flex items-center space-x-3 px-4 py-3 text-gray-600 hover:text-juv-terracotta hover:bg-juv-soft-blush/10 transition-all duration-200 rounded-lg"
                    >
                      {item.icon}
                      <div>
                        <div className="font-medium">{item.name}</div>
                        <div className="text-xs text-gray-500">{item.description}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AboutDropdown;
